{
  "title": "How to Accept a Judge Invitation and Sign In",
  "description": "Activate your account and sign in to the judging system after the organizer invites you.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, you'll be signed in as a judge and able to see the submissions assigned to you.",
  "roleNote": "Judge",
  "prerequisites": ["You've received a judge invitation email from the organizer"],
  "pathLabel": "Login Page",
  "steps": [
    {
      "title": "1. Check the invitation email",
      "description": "The organizer sends the judge invitation by email. If your email already has a platform account, the email only asks you to sign in and contains no password; if not, it includes a temporary initial password meant only for you."
    },
    {
      "title": "2. Existing account: sign in, then accept or decline",
      "description": "After signing in with your existing account, press \"Accept invitation\" under \"Judge invitations waiting for your answer\" on your Overview page; you become a judge of that competition only after accepting, and \"Go to judging assignments\" opens the workspace. If you cannot serve, press \"Decline\" and optionally give a reason; the organizer sees \"Declined\" with the reason in the invitation list. An invitation can be answered for 7 days."
    },
    {
      "title": "3. New account: sign in with the temporary password",
      "description": "Sign in using the account email and temporary password from the email; the temporary password currently expires after 48 hours (subject to change). Once you sign in, a \"Set your new password\" screen replaces the rest of the site right away. Enter a password of at least 10 characters and submit to finish; until then you cannot access any judge- or competition-protected data, though the header's account menu (including sign out) still works. Once you submit successfully, the judge workspace loads on its own, with no need to refresh or sign in again."
    }
  ],
  "afterward": [
    "After signing in you'll see the judge workspace",
    "Submissions assigned to you appear in the list",
    "All further communication is sent to the email you sign in with"
  ],
  "nextSteps": "Next, go to the judge workspace to view your assigned submissions and start scoring.",
  "faq": [
    {
      "q": "What if my temporary password expired or I lost it?",
      "a": "The temporary password only ever appears once, in the notification email that generated it; the database stores only a hash and it can't be looked up. The quickest fix is \"Forgot password\" on the sign-in page: a reset link goes to the mailbox the invitation was sent to, and once you set a new password you can sign in directly as a judge. Alternatively, ask the organizer to click \"Resend\" on the \"Judge Invitations & Assignments\" page, which generates a new password and immediately invalidates the old one. Invite an address you check regularly (for example Gmail)."
    },
    {
      "q": "After my first sign-in, I see a \"Set your new password\" screen instead of the site. Is that normal?",
      "a": "Yes, this is expected, not a bug. Every first sign-in with a temporary password shows this screen, replacing the rest of the site. Enter a new password and submit, and the site continues on its own; no need to refresh or sign in again."
    }
  ]
}
